<template>
    <div>
        <Button
            icon="pi pi-print"
            class="p-button-rounded p-button-text p-button-sm"
            @click="baixarRelatorio"
            v-tooltip.top="'Obter Relatório Individual'"
            :loading="carregando"
        />

        <visualizar-anexo :mostrar="mostrar" :titulo="titulo" @cancelar="fechar()">
            <iframe v-if="arquivo" :src="arquivo" :title="titulo" style="width: 100%; height: 850px"></iframe>
        </visualizar-anexo>
    </div>
</template>

<script>
import RelatorioServices from './services';
import VisualizarAnexo from '../../../../../licitacoes/solicitacoes/VisualizarAnexo.vue';

export default {
    name: 'BtnRelatorioIndividual',

    components: {
        VisualizarAnexo,
    },

    props: {
        despesa: {
            type: Object,
            required: true,
        },
        convenioId: {
            type: [String, Number],
            required: true,
        },
    },

    data() {
        return {
            carregando: false,
            mostrar: false,
            titulo: '',
            arquivo: null,
        };
    },

    methods: {
        async baixarRelatorio() {
            this.carregando = true;
            this.$store.dispatch('addRequest');

            try {
                const response = await RelatorioServices.obterRelatorioDespesaIndividual(this.convenioId, this.despesa.convenioDespesaId);
                if (response?.data) {
                    const blob = new Blob([response.data], { type: 'application/pdf' });

                    this.arquivo = window.URL.createObjectURL(blob);

                    this.mostrar = true;
                    this.titulo = `Relatório Despesa Individual - ${this.despesa.descricao}`;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Sucesso',
                        detail: 'Relatório individual baixado com sucesso',
                        life: 3000,
                    });
                }
            } catch {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao baixar relatório individual',
                    life: 3000,
                });
            } finally {
                this.carregando = false;
                this.$store.dispatch('removeRequest');
            }
        },

        fechar() {
            this.mostrar = false;
            if (this.arquivo) {
                window.URL.revokeObjectURL(this.arquivo);
                this.arquivo = null;
            }
        },
    },
};
</script>
